import { FC } from 'react'
import styles from './CommonErorr.module.scss'

interface CommonErrorProps {
  errors: {
    _common?: string
    [key: string]: string
  }
}
export const CommonError: FC<CommonErrorProps> = ({ errors }) => {
  if (errors._common) {
    return <div className={styles.container}>{errors._common}</div>
  } else {
    return null
  }
}
